export enum AccountToggle {
    CrossProfileEngage = 'cross_profile_engage'
}

export enum UserToggle {
    CanModifyCrossProfileDefault = 'can_modify_cross_profile_default',
    CanEngageCrossProfile = 'can_engage_cross_profile',
    CanManageShadowBanning = 'can_manage_shadow_banning',
    EnableKeywords = 'keywords_enabled',
    CanViewScreenshots = 'can_view_screenshots',
    AskArwenEnabled = 'ask_arwen_enabled',
    CanLabelSpam = 'can_label_spam',
    CanHideContent = 'can_hide_content',
    CanDeleteContent = 'can_delete_content',
    CanBlockUser = 'can_block_user',
    CanMuteUser = 'can_mute_user',
    ConversationViewEnabled = 'conversation_view_enabled'
}
